import { FilterSection } from "../../../data-model/filterValues";
import { PharmaStpFileModel } from "../../../data-model/nycbsPharmaOrder";
import { allCmmOptions } from "./filterOptions/cmmFilterOptions";
import { allLetterUploadOptions } from "./filterOptions/letterUploadFilterOptions";
import { allPocOptions } from "./filterOptions/pocFilterOptions";
import { allResponseStatusOptions } from "./filterOptions/responseStatusFilterOptions";
import { allRouteViaOptions } from "./filterOptions/routeViaFilterOptions";
import { allSecondStpStatusOptions } from "./filterOptions/secondStpStatusFilterOptions";
import { allSftpOptions } from "./filterOptions/sftpOptions";
import { allTextNoteOptions } from "./filterOptions/textNotesFilterOptions";

export enum PharmaStpFileFilterKeys {
  DOW = "dow",
  BATCH = "batch",
  RESPONSE_STATUS = "response_status",
  SECOND_STP_STATUS = "second_stp_status",
  POC = "poc",
  SFTP_STATUS = "sftp_status",
  TEXT_NOTE_STATUS = "text_note_status",
  CMM = "cmm",
  LETTER_UPLOAD = "letter_upload",
  ROUTE_VIA = "route_via",
}

export const createFilterForDOW = (
  data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: PharmaStpFileFilterKeys.DOW,
    label: "DOW",
    options: [],
    type: "date",
  };
};

export const createFilterForBatch = (
  data: PharmaStpFileModel[],
): FilterSection => {
  const uniqueBatches = Array.from(
    new Set(
      data
        .map((item) => {
          const fileName = item?.filename ?? "";
          return fileName;
        })
        .filter((batch): batch is string => Boolean(batch) && batch !== "--"),
    ),
  ).sort();

  return {
    id: PharmaStpFileFilterKeys.BATCH,
    label: "Batch",
    options: uniqueBatches.map((batch) => ({
      label: batch,
      value: batch,
    })),
    type: "string",
  };
};

export const createFilterForResponseStatus = (
  data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: PharmaStpFileFilterKeys.RESPONSE_STATUS,
    label: "Response Status",
    options: allResponseStatusOptions,
    type: "string",
  };
};

export const createFilterForSecondStpStatus = (
  _data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: PharmaStpFileFilterKeys.SECOND_STP_STATUS,
    label: "2nd STP Status",
    options: allSecondStpStatusOptions,
    type: "string",
  };
};

export const createFilterForPoc = (
  data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: PharmaStpFileFilterKeys.POC,
    label: "POC",
    options: allPocOptions,
    type: "string",
  };
};

export const createFilterForSftpStatus = (
  data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: PharmaStpFileFilterKeys.SFTP_STATUS,
    label: "SFTP",
    options: allSftpOptions,
    type: "string",
  };
};

export const createFilterForTextNoteStatus = (
  data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: PharmaStpFileFilterKeys.TEXT_NOTE_STATUS,
    label: "Text Note",
    options: allTextNoteOptions,
    type: "string",
  };
};

export const createFilterForCmm = (
  data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: PharmaStpFileFilterKeys.CMM,
    label: "CMM",
    options: allCmmOptions,
    type: "string",
  };
};

export const createFilterForLetterUpload = (
  data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: PharmaStpFileFilterKeys.LETTER_UPLOAD,
    label: "Letter Upload",
    options: allLetterUploadOptions,
    type: "string",
  };
};

export const createFilterForRouteVia = (
  data: PharmaStpFileModel[],
): FilterSection => {
  return {
    id: PharmaStpFileFilterKeys.ROUTE_VIA,
    label: "Route Via",
    options: allRouteViaOptions,
    type: "string",
  };
};

export const createAllFilterSections = (
  data: PharmaStpFileModel[],
): FilterSection[] => {
  if (!data || data.length === 0) {
    return [];
  }

  return [
    createFilterForDOW(data),
    createFilterForBatch(data),
    createFilterForSecondStpStatus(data),
    createFilterForResponseStatus(data),
    createFilterForLetterUpload(data),
    createFilterForCmm(data),
    createFilterForSftpStatus(data),
    createFilterForTextNoteStatus(data),
    createFilterForPoc(data),
    createFilterForRouteVia(data),
  ];
};
